import { useState, useRef, useEffect } from "react";
import closeIconW from "../../assets/img/close-w.png";
import "./multi-select-dropdown.css";

export default function MultiSelectDropdown({ options, value = [], onChange }) {
    const [selected, setSelected] = useState(value);
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);

    const toggleOption = (option) => {
        const newSelected = selected.includes(option)
            ? selected.filter((o) => o !== option)
            : [...selected, option];

        setSelected(newSelected);

        if (onChange) {
            onChange(newSelected);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        setSelected(value);
    }, [value]);

    return (
        <div className="multi-select-wrapper" ref={wrapperRef}>
            <div className="selected-box" onClick={() => setOpen((prev) => !prev)}>
                {selected.map((option) => (
                    <div key={option} className="tag" onClick={(e) => {
                        e.stopPropagation();
                        toggleOption(option);
                    }} >
                        {option}

                        <img
                            src={closeIconW}
                            className="remove-btn"
                            alt="close icon"
                        />

                    </div>
                ))}
                {selected.length === 0 && <span className="placeholder">Select turbines...</span>}
            </div>

            {open && (
                <div className="dropdown">
                    {options.map((option) => (
                        <div
                            key={option}
                            onClick={() => toggleOption(option)}
                            className={`option ${selected.includes(option) ? "selected" : ""}`}
                        >
                            {option}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
